import '@/app/app.css';
import './privacy-policy.css';

import '@/app/app';
import '@/layouts/main/main.js';

window.addEventListener('DOMContentLoaded', () => {});
